import { useLocation } from "react-router";
import LoginLayout from "../../shared-components/login-layout/login-layout";
import OtpVerificationForm from "./otp-verification-form/otp-verification-form";

const VerifyOtp = () => {
  const { state } = useLocation();
  const { value, whereTo } = state;
  return (
    <LoginLayout
      title={"Verify Email"}
      subTitle={
        <>
          An OTP has been sent to{" "}
          <span style={{ color: "#2F2A89" }}>{value}</span> with 6 digits. Enter
          the OTP below to confirm Email.
        </>
      }
      showBackButton={false}
    >
      <OtpVerificationForm whereTo={whereTo} value={value} />
    </LoginLayout>
  );
};

export default VerifyOtp;
